import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-97380d52"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "personalis_care" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hightText" }, "AI-Enhanced ", -1))
const _hoisted_3 = { class: "dec" }
const _hoisted_4 = { class: "text" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " At Sixliv, we handle your clinic operations 24/7, so you can focus on exceptional care. Our AI innovative healthcare solutions, based on lifestyle medicine, prioritise patients' overall well-being. We streamline operations, enhance engagement, and improve outcomes ", -1))
const _hoisted_6 = ["src"]

import { ElButton } from "element-plus";
import { store } from "@/utils/store";
import { onMounted, reactive } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'PersonalisCare',
  setup(__props) {

const handleOpenMobileSignUp = () => {
  store.handleOpenMobileLogin();
};
const pageTopPic = reactive({
  url: "",
  tabs: [],
});
onMounted(() => {
  if (localStorage.getItem("PAGE_TOP")) {
    pageTopPic.url = JSON.parse(localStorage.getItem("PAGE_TOP") || "").url || "";
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createTextVNode(" Everyone is Different. Feel Better, Live Happier with Sixliv's "),
    _hoisted_2,
    _createTextVNode(" Personalized Care. "),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_unref(ElButton), {
          onClick: handleOpenMobileSignUp,
          class: "signup"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Sign Up")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("img", {
        src: pageTopPic.url,
        alt: ""
      }, null, 8, _hoisted_6)
    ])
  ]))
}
}

})